import { useMutation } from '@tanstack/react-query';
import type { Customer, CustomerLookupBy } from '../types';
import { useCustomersSyncApi } from './use-customers-sync-api';
import { useCustomersSyncSettings } from './use-customers-sync-settings';

export function useUpdateCustomerRole(lookupBy: CustomerLookupBy, identifier: string) {
  const { customersSyncApi } = useCustomersSyncApi();
  const settings = useCustomersSyncSettings();

  return useMutation<Customer, unknown, { role: string }>({
    mutationFn: (payload) => customersSyncApi.updateRole(lookupBy, identifier, payload, settings),
  });
}
